import { schema } from 'normalizr';
import { Session } from '@app/api';
import { Participant } from '@app/api';
import {
  ParticipantTag,
  PARTICIPANT_TAGS_ENTITY_NAME,
  participantTagsSchema,
} from 'store/Participant';

export interface Panel {
  id: string;
  name: string;
  subscriptionFormId?: string;
  panelSubscriptionSettings?: PanelSubscriptionSettings;
  tags: ParticipantTag[];
  organizationId?: string;
  deletedAt?: Date;
  createdAt: Date;
}

export interface PanelSubscriptionSettings {
  id: string;
  title?: string | null;
  logoUrl?: string | null;
  tags: ParticipantTag[];
  panelId: string;
  panel?: Panel;
  fields?: Array<keyof Participant | string>;
}

export interface Organization {
  id: string;
  name: string;
  panels: Panel[];
  sessions?: Session[];
}

export interface InvitedOrganizationMember {
  id: string;
  email: string;
  organizationId: string;
  organizationName: string;
  validUntil: string;
}

export const ORGANIZATION_ENTITY_NAME = 'organizations';
export const PANEL_ENTITY_NAME = 'panels';
export const PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME =
  'panelSubscriptionSettings';

export const panelLinkedEntities = [
  PANEL_ENTITY_NAME,
  PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
  PARTICIPANT_TAGS_ENTITY_NAME,
];
export const subscriptionSettingsLinkedEntities = [
  PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
  PARTICIPANT_TAGS_ENTITY_NAME,
];

export const panelSubscriptionSettingsSchema = new schema.Entity(
  PANEL_SUBSCRIPTION_SETTINGS_ENTITY_NAME,
  {
    tags: new schema.Array(participantTagsSchema),
  },
);

export const organizationLinkedEntities = [
  ORGANIZATION_ENTITY_NAME,
  ...panelLinkedEntities,
];
export const panelSchema = new schema.Entity(PANEL_ENTITY_NAME, {
  panelSubscriptionSettings: panelSubscriptionSettingsSchema,
  tags: new schema.Array(participantTagsSchema),
});
export const organizationSchema = new schema.Entity(ORGANIZATION_ENTITY_NAME, {
  panels: [panelSchema],
});
